// var moment = require('moment')
import api from '../../models/dayoff'
import addDayoffModal from '../../components/modal/dayoff_add_modal'
import editDayoffModal from '../../components/modal/dayoff_edit_modal'

export default {
  name: 'dayoff',
  components: {
    addDayoffModal,
    editDayoffModal,
  },
  data() {
    return {
      is_load: false,
      years: [],
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July ',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      date: new Date(),
      current_ymd: [],
      active_ym: [],
      render_m: 0,
      render_y: 0,
      calendar: [],
      modal_type: 'add',
      modal_data: {
        cdof_title: '',
        cdof_date: '',
        cdof_is_active: 1,
        cdof_type: 1,
      },
    }
  },
  created() {
    this.checkOAuth()
    this.current_ymd['d'] = this.date.getDate()
    this.current_ymd['m'] = this.date.getMonth()
    this.current_ymd['y'] = this.date.getFullYear()

    this.active_ym['m'] = this.date.getMonth()
    this.active_ym['y'] = this.date.getFullYear()

    this.render_m = this.date.getMonth()
    this.render_y = this.date.getFullYear()

    let min_year = parseInt(this.current_ymd['y']) - 10
    let max_year = parseInt(this.current_ymd['y']) + 10

    for (let i = min_year; i <= max_year; i++) {
      this.years.push(i)
    }
  },
  mounted() {
    setTimeout(() => {
      if (sessionStorage.token) {
        this.renderCalendar()
      } else {
        setTimeout(() => {
          this.renderCalendar()
        }, 1000)
      }
    }, 1000)
  },
  methods: {
    next() {
      this.active_ym['y'] =
        this.active_ym['m'] === 11
          ? this.active_ym['y'] + 1
          : this.active_ym['y']
      this.active_ym['m'] =
        this.active_ym['m'] === 11 ? 0 : this.active_ym['m'] + 1
      this.reAssign()
      this.renderCalendar()
    },
    previous() {
      this.active_ym['y'] =
        this.active_ym['m'] === 0
          ? this.active_ym['y'] - 1
          : this.active_ym['y']
      this.active_ym['m'] =
        this.active_ym['m'] === 0 ? 11 : this.active_ym['m'] - 1
      this.reAssign()
      this.renderCalendar()
    },
    current() {
      this.active_ym['y'] = this.current_ymd['y']
      this.active_ym['m'] = this.current_ymd['m']
      this.reAssign()
      this.renderCalendar()
    },
    selected() {
      this.active_ym['m'] = this.render_m
      this.active_ym['y'] = this.render_y
      this.renderCalendar()
    },
    reAssign() {
      // fix rerendering
      this.render_m = this.active_ym['m']
      this.render_y = this.active_ym['y']
    },
    renderCalendar() {
      if (this.is_load === false) {
        this.is_load = true
        let year = this.active_ym['y']
        let month = this.active_ym['m']
        let month_ = month + 1
        let ym = year + '-' + (month_ < 10 ? '0' + month_ : month_)
        // get dayoff
        api.getDayoffYm(
          this.$store.state.URLHost,
          ym,
          this.header,
          (result) => {
            if (result.response === true) {
              // set rendering
              let first_day = new Date(year, month).getDay()
              let day_in_month = new Date(year, month + 1, 0).getDate()
              // console.log(day_in_month)
              let day = 1
              let temp_calendar = []
              for (let r = 0; r < 6; r++) {
                if (day <= day_in_month) {
                  temp_calendar[r] = []
                  for (let c = 0; c < 7; c++) {
                    if (r === 0 && c < first_day) {
                      temp_calendar[r][c] = {
                        day: '',
                        dayoff: null,
                      }
                    } else if (day > day_in_month) {
                      temp_calendar[r][c] = {
                        day: '',
                        dayoff: null,
                      }
                    } else {
                      let ymd = ym + '-' + (day < 10 ? '0' + day : day)
                      let index = result.data.dayoffs.findIndex(
                        (dayoff) => dayoff.cdof_date === ymd
                      )
                      if (index !== -1) {
                        temp_calendar[r][c] = {
                          day: day,
                          date: ymd,
                          dayoff: result.data.dayoffs[index],
                        }
                      } else {
                        temp_calendar[r][c] = {
                          day: day,
                          date: ymd,
                          dayoff: null,
                        }
                      }
                      day++
                    }
                  }
                }
              }
              this.calendar = temp_calendar
            }
            this.is_load = false
          },
          (error) => {
            this.alert_msg('error', 'An error occurred.', error.message)
            this.is_load = false
          }
        )
      }
    },
    manageCalendar(obj) {
      if (!obj.dayoff) {
        this.modal_type = 'add'
        this.modal_data = {
          cdof_id: '',
          cdof_title: '',
          cdof_date: obj.date,
          cdof_is_active: 1,
          cdof_type: 1,
        }
        this.ModalBoots('dayoff_modal').show()
      } else {
        this.modal_type = 'edit'
        this.modal_data = {
          cdof_id: obj.dayoff.cdof_id,
          cdof_title: obj.dayoff.cdof_title,
          cdof_date: obj.date,
          cdof_is_active: obj.dayoff.cdof_is_active === 'Active' ? 1 : 0,
          cdof_type: obj.dayoff.cdof_type === 'Day Off' ? 1 : 0,
        }
        this.ModalBoots('dayoff_modal').show()
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/dayoff.js